import styles from "../RegistrationPage.module.scss";
import classNames from "classnames";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "./ErrorMessage";
import { yupResolver } from "@hookform/resolvers/yup";

import * as yup from "yup";
interface AuthFormProps {
  onValidSubmit: (email: string) => void;
  onSwitchToReg: () => void;
}

const schema = yup.object({
  email: yup
    .string()
    .trim()
    .lowercase()
    .required("Почта обязательна")
    .email("Некорректный формат почты")
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Некорректный формат почты")
    .max(100, "Максимальная длина почты 100 символов"),
});
type FormValues = yup.InferType<typeof schema>;

export const AuthForm: React.FC<AuthFormProps> = ({
  onValidSubmit,
  onSwitchToReg,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({ resolver: yupResolver(schema) });
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const onSubmit = async (data: FormValues) => {
    setIsLoading(true);
    setErrorMessage(null);

    try {
      // await authUser(data.email);
      onValidSubmit(data.email);
    } catch (error: any) {
      let message = "Ошибка авторизации, попробуйте снова.";

      if (error.message.includes("Network Error")) {
        message = "Проблема с интернетом. Проверьте соединение.";
      } else if (error.response?.status >= 500) {
        message = "Сервер временно недоступен, попробуйте позже.";
      } else if (error.response?.status === 404) {
        message = "Пользователь с такой почтой не найден";
      }

      setErrorMessage(message);
    } finally {
      setIsLoading(false);
    }
    //если пользователь не найден, регистрируем
    // if (error.message.includes("Пользователь не найден")) {
    //   try {
    //     const newUser = await registerUser("", data.email);
    //     const loggedInUser = await loginUser(newUser.email);
    //     onValidSubmit(loggedInUser.email);
    //   } catch (regError) {
    //     setErrorMessage("Не удалось зарегистрировать пользователя.");
    //   }
    // } else if (error.message.includes("Ошибка сети")) {
    //   setErrorMessage("Проблема с интернетом. Проверьте соединение.");
    // } else if (error.message.includes("Ошибка сервера")) {
    //   setErrorMessage("Сервер временно недоступен, попробуйте позже.");
    // } else {
    //   setErrorMessage("Ошибка авторизации, попробуйте снова.");
    // }
  };

  return (
    <>
      <form
        className={classNames(styles.form, styles.formgap_1)}
        onSubmit={handleSubmit(onSubmit)}
        style={{ marginBottom: "302px" }}
      >
        <h2 className={styles.form_title}>Войти в аккаунт</h2>

        <div className={styles.form_inputWrapp}>
          <label htmlFor="userEmail" className={styles.form_emailLabel}>
            Введите электронную почту{" "}
          </label>
          <input
            id="userEmail"
            className={classNames(styles.input, styles.emailInput)}
            {...register("email")}
            // placeholder="ipvanino@gmail.com"
            aria-invalid={errors.email ? "true" : "false"}
          />
          {/*ошибки валидации */}
          {errors.email && (
            <span className={styles.errorMessage}>{errors.email.message}</span>
          )}
          <ErrorMessage message={errorMessage ?? undefined} />
        </div>
        <button className={styles.form_submitBtn} disabled={isLoading}>
          {isLoading ? (
            <>
              Отправка
              <span className={styles.spinner}></span>
            </>
          ) : (
            "Отправить код на почту"
          )}
        </button>
      </form>
    </>
  );
};
